import { io } from 'socket.io-client';
import { url } from './utils/Constant';
const socket = io(url, { autoConnect: false });

export default socket;
